import { AutogenLayoutTerminalCodeList } from "./autogen/AutogenLayoutTerminalCodeList";

export class TerminalCodeList extends AutogenLayoutTerminalCodeList {
    onLoad(): void | Promise<void> {
        this.mainDataSource.orderBy = [{ field: "descr", sort: "asc" }];
    }
}
